import { AUTH } from '../constants';
import { redirectRequest, msalConfig } from '../constants/authConfig';
import authService from '../services/auth/auth.service';
import AuthFacade from '../redux/auth/Auth.facade';
import { useMsal } from '@azure/msal-react';
const useAuth = () => {
  const { handleLogout, accessTokenForUserRole, fallBackRefreshToken } =
    AuthFacade();  
  const {instance} = useMsal();
  const refreshToken = async (accountDetail) => {
    console.log('refreshToken :', accountDetail)
    try {
      if(accountDetail && instance){
        const request = {
          ...redirectRequest,
          account: accountDetail,
          forceRefresh: true
        };
        await instance.acquireTokenSilent(request).then((accessTokenResponse) => {
          if(accessTokenResponse.accessToken){
            sessionStorage.setItem('token', accessTokenResponse.accessToken);
            fallBackRefreshToken(false);
          }
        });
      }
    } catch (error) {
      fallBackRefreshToken(true);
      console.error('Error acquiring token:', error);
    }
  };

  const logout = async () => {
    const logoutRequest = {
      postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
    };
    await authService.initialize(); // Initialize MSAL instance
    await authService.logoutRedirect(logoutRequest);
    handleLogout();
  };

  //getLoginAccessToken
  const getLoginAccessToken = async () => {
    if (sessionStorage) {
      const seeAccessTokenKey = Object.keys(sessionStorage).find((ele) =>
        ele.includes(AUTH.accessToken)
      );
      const accessTokenData = seeAccessTokenKey
        ? JSON.parse(sessionStorage.getItem(seeAccessTokenKey)).secret
        : '';
      if (accessTokenData !== '') accessTokenForUserRole(accessTokenData);
    }
  };

  return {
    logout,
    refreshToken,
    getLoginAccessToken,
  };
};

export default useAuth;
